import createAuth0Client from "@auth0/auth0-spa-js";

// Vue 2 reactive wrapper for the Auth0 SDK.
export const auth0Options = ({
  onRedirectCallback = () => {},
  ...options
}) => ({
  data: () => ({
    loading: true,
    isAuthenticated: false,
    user: {},
    error: null,
    auth0Client: null,
  }),
  methods: {
    loginWithRedirect(options) {
      return this.auth0Client.loginWithRedirect(options);
    },
    async loginWithPopup(options) {
      await this.auth0Client.loginWithPopup(options);
      this.user = (await this.auth0Client.getUser()) || {};
      this.isAuthenticated = await this.auth0Client.isAuthenticated();
    },
    getTokenSilently(options) {
      return this.auth0Client.getTokenSilently(options);
    },
    getTokenWithPopup(options) {
      return this.auth0Client.getTokenWithPopup(options);
    },
    getIdTokenClaims(options) {
      return this.auth0Client.getIdTokenClaims(options);
    },
    handleRedirectCallback() {
      return this.auth0Client.handleRedirectCallback();
    },
    logout(options = {}) {
      return this.auth0Client.logout({ returnTo: location.origin, ...options });
    },
  },
  async created() {
    try {
      this.auth0Client = await createAuth0Client({
        ...options,
        client_id: options.clientId,
        redirect_uri: `${location.origin}/`,
      });
      const query = new URLSearchParams(location.search);
      if (query.has("code") && query.has("state")) {
        const { appState } = await this.auth0Client.handleRedirectCallback();
        history.replaceState({}, document.title, "/");
        onRedirectCallback(appState);
      }
      this.user = (await this.auth0Client.getUser()) || {};
      this.isAuthenticated = await this.auth0Client.isAuthenticated();
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  },
});
